import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pdf-container" }
const _hoisted_2 = {
  key: 0,
  class: "state-container"
}
const _hoisted_3 = {
  key: 1,
  class: "state-container error-text"
}

import {onMounted, onUnmounted, ref, watch} from 'vue'
import {useRoute} from 'vue-router'
import {useI18n} from 'vue-i18n'
import {Sessions} from '@/assets/ts/sessions'

const pageStr = 'components.itemV2.itemV2PrintOut'

export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2PrintOut',
  setup(__props) {

const route = useRoute()
const {t} = useI18n()
const sessionsApi: Sessions = new Sessions()

const loading = ref(false)
const error = ref<number | null>(null)
const pdfUrl = ref<string | null>(null)
let isRedirecting = false

const loadPdf = async () => {
  const routeSessionId = route.params.sessionId?.toString() || ''
  if (!routeSessionId) return

  loading.value = true
  error.value = null
  try {
    const data: any = await sessionsApi.getPdf(routeSessionId)
    if (data.file) {
      if (pdfUrl.value) {
        URL.revokeObjectURL(pdfUrl.value)
      }
      const pdfBase64 = data.file
      const byteCharacters = atob(pdfBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], {type: 'application/pdf'})
      pdfUrl.value = URL.createObjectURL(blob)
      isRedirecting = true
      window.location.replace(pdfUrl.value)
    } else if (typeof data.error !== 'undefined') {
      error.value = data.error
    }
  } catch (e) {
    console.error(e)
    error.value = 500
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  loadPdf()
  document.title = t(pageStr + '.configuration_printout')
})

onUnmounted(() => {
  if (pdfUrl.value && !isRedirecting) {
    URL.revokeObjectURL(pdfUrl.value)
  }
})

watch(
    () => route.params.sessionId,
    () => loadPdf()
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)(pageStr + '.loading_configuration')), 1)
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)(pageStr + '.error')) + " " + _toDisplayString(error.value), 1)
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})